import { IonIcon } from '@ionic/react';
import { globeOutline } from 'ionicons/icons';
import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { DIALOGUE_SUPPORT_EMAIL, S3_BUCKET_URL } from '@/constants';
import { useAccount } from '@/hooks/useAccount';
import { apiV1GetMeAuthRequest } from '@/modules/api';
import { webCampaign } from '@/modules/webCampaign';

import { StoreLinks } from '../StoreLinks';

import { ContentStyles, WebVersionLinkStyles } from './Content.styles';

export const Content = () => {
  const { user } = useAccount();

  const [authToken, setAuthToken] = React.useState<string | null>(null);

  React.useEffect(() => {
    const fetchAuthToken = async () => {
      const auth = await apiV1GetMeAuthRequest();
      setAuthToken(auth.token);
    };
    fetchAuthToken();
  }, []);

  return (
    <ContentStyles className="content">
      <div className="phrase">
        <img
          src={`${S3_BUCKET_URL}/paywall/cant-wait-phrase.png`}
          alt="phrase"
        />
      </div>
      <div className="next-actions">
        <UiTypography variant="headline-large" className="next-actions-title">
          What’s next?
        </UiTypography>
        <UiTypography
          align="center"
          variant="body-large"
          className="next-action-description"
        >
          Download Dialogue app from your store
        </UiTypography>

        <StoreLinks />

        {webCampaign.setup.hasWebAppLink && !!authToken && (
          <WebVersionLinkStyles>
            <a href={webCampaign.getAuthUrl(authToken)} target="_blank">
              <IonIcon icon={globeOutline} />
              <UiTypography variant="label-large" color="white">
                Web version
              </UiTypography>
            </a>
          </WebVersionLinkStyles>
        )}

        <UiTypography variant="body-large" align="center">
          OR via the link we sent to {user?.email} (check Inbox and Spam).
        </UiTypography>
      </div>
      <UiTypography
        variant="body-medium"
        className="questions-email"
        align="center"
      >
        If you have any questions - reach us at{' '}
        <a href={`mailto:${DIALOGUE_SUPPORT_EMAIL}`} target="_blank">
          {DIALOGUE_SUPPORT_EMAIL}
        </a>
      </UiTypography>
    </ContentStyles>
  );
};
